/**
 * ehr#623 (reopened 10-24) - what the chart header's owner chip says. The chart used to open
 * with "Unassigned" and switch to the owner's name 1 to 4 seconds later, once the people list
 * loaded. Until the chart's own record is read the chip is blank (no name, no "Unassigned");
 * then it names the owner, or says Unassigned only when the client really has no owner.
 */
export interface OwnerChip {
  /** Still loading: show a blank placeholder. */
  pending: boolean;
  /** The name shown ('' while pending). */
  text: string;
  /** Avatar initials ('' while pending, '?' with no owner). */
  initials: string;
}

export function ownerChip(ready: boolean, owner: string | null | undefined): OwnerChip {
  if (!ready) return { pending: true, text: '', initials: '' };
  const name = owner?.trim();
  if (!name) return { pending: false, text: 'Unassigned', initials: '?' };
  return { pending: false, text: name, initials: initialsOf(name) };
}

/** "Jennifer Park" is "JP"; an email is its first letter. */
export function initialsOf(name: string): string {
  const words = name.includes('@') ? [name] : name.split(/\s+/).filter(Boolean);
  const first = words[0]?.[0] ?? '';
  const last = words.length > 1 ? (words[words.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase() || '?';
}
